exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-size-1[data-v-06acba14]{font-size:1.2rem}.id-list p[data-v-06acba14]{margin-bottom:.6rem!important}", ""]);

// exports
